import React, { useContext, useEffect, useRef } from "react";
import FiltersCarousel from "./FiltersCarousel";
import { ProgramsContext } from "../../context/ProgramsContext";
import { S3_ENDPOINT } from "../../utils";
import { ClassTypeContext } from "../../context/ClassTypesContext";
import useFreeTrial from "../../hooks/useFreeTrial";

export default function LandingOnlineFilters() {
  const containerRef = useRef(null);
  const { getPrograms, programs } = useContext(ProgramsContext);
  const { class_types } = useContext(ClassTypeContext);
  const { handleFreeTrial } = useFreeTrial();

  // Usamos IntersectionObserver para detectar la visibilidad
  useEffect(() => {
    getPrograms();
    const observerOptions = {
      root: null, // Usamos la ventana de visualización
      rootMargin: "0px",
      threshold: 0.3, // Al 10% del componente visible, se activa la animación
    };

    // Función para manejar la visibilidad del componente
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove("opacity-0");
          entry.target.classList.add("animate-fade-in");
        }
      });
    };

    // Creamos el IntersectionObserver
    const observer = new IntersectionObserver(
      handleIntersection,
      observerOptions,
    );

    // Observamos los componentes
    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      // Limpiamos el observer cuando el componente se desmonte
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  const filtersList = [
    "Busca la clase por su nombre",
    "Filtra por categoría: Fuerza, Cardio, Magic Key y más",
    "Filtra por coach",
    "Filtra por duración: desde menos de 20 min hasta más de 1 hora",
    "Filtra por grupo muscular",
    "Filtra por nivel de impacto",
  ];

  const filteredClassTypes = class_types?.filter((type) => {
    return type.file && type.file?.type && type.file?.name;
  });

  const renderFiltersList = () => {
    return filtersList.map((filter, index) => (
      <div key={index} className="filters__item d-flex align-items-center">
        <i className="fas fa-check-circle me-2 text-dark" aria-hidden />
        <div className="filters__item-text text-dark">{filter}</div>
      </div>
    ));
  };

  const renderPrograms = () => {
    if (Array.isArray(programs) && programs.length > 0) {
      const filteredPrograms = programs?.filter((program) => {
        return program.name !== "Estrenos";
      });

      const sortedPrograms = [
        /* { name: "Estrenos", color: "rgb(237,184,128)", icon: "iconosTBM-01.png" },*/
        filteredPrograms[0],
        filteredPrograms[1],
        filteredPrograms[2],
        filteredPrograms[3],
      ];

      return sortedPrograms.map((program, index) => (
        <div
          className=" col-6 col-sm-3 col-lg-6 position-relative custom-ratio"
          // style={{ height: "calc(=" }}
        >
          <div
            style={{ backgroundColor: program.color }}
            className="br-10 h-100 d-flex flex-column justify-content-center align-items-center"
          >
            <div className="programa-overlay bg-black br-10"></div>
            <img
              src={`${S3_ENDPOINT}/${program.icon}`}
              alt="Imagen 1"
              className=" rounded-none"
              style={{ width: "40%" }}
            />
            <h6 className="text-white m-0">{program.name}</h6>
          </div>
        </div>
      ));
    }
  };
  return (
    <div id="filtros" className="online-filters bg-white ">
      <div ref={containerRef} className="opacity-0">
        <div
          className="d-flex justify-content-between mx-auto filters__container"
          style={{ maxWidth: "1100px" }}
        >
          <div className="filters__list">
            <h6 className="online-subtitle text-dark mb-1">
              Encuentra tu clase ideal
            </h6>
            <h2 className="online-title text-dark">
              Filtra según lo que necesitas hoy
            </h2>
            {renderFiltersList()}
          </div>

          <div className="filters__programas">
            <h6 className="online-subtitle text-dark mb-3">
              Explora por programa
            </h6>
            <div className="row g-4">{renderPrograms()}</div>
          </div>
        </div>

        <div className="online-filters__carrousel d-flex flex-column align-items-center">
          <h6 className="online-subtitle text-dark w-100 text-md-center ">
            Explora por disciplina
          </h6>
          <FiltersCarousel
            options={{ loop: true, duration: 30 }}
            slides={filteredClassTypes}
          />
          <button
            onClick={handleFreeTrial}
            type="button"
            className="btn btn-primary mt-md-5 mt-3"
          >
            Pruébalo 7 días gratis
          </button>
        </div>
      </div>
    </div>
  );
}
